import React from "react";
import "../../pages/style.css";
import { Container, Row, Col } from "react-bootstrap";

import imageone from "../../Assets/still life pumkin.jpg";
import imagetwo from "../../Assets/fruit.jpg";
import imagethree from "../../Assets/shapes.jpg";
import imagefour from "../../Assets/shapestwo.jpg";
import imagefive from "../../Assets/iron.jpg";
import imagesix from "../../Assets/shapesthree.jpg";

import imageseven from "../../Assets/Lopez-Donald-Infographic-072920.jpg";
import imageseventeen from "../../Assets/Lopez-Donald-Logo-SimpleForm-072020.jpg";

import imagenine from "../../Assets/Lopez-Donald-Painting-020419.jpg";
import imagethirtyfour from "../../Assets/Lopez-Donald-Painting.jpg";

import imageten from "../../Assets/Ruby.jpg";
import imageeleven from "../../Assets/Sentinal.jpg";
import imagetwelve from "../../Assets/Orion.jpg";
import imagethirdteen from "../../Assets/Shadow2.jpg";
import imagefifteen from "../../Assets/RoS B1 pg4.jpg";
import imagesixteen from "../../Assets/RoS B1 pg3.jpg";
import imageeighteen from "../../Assets/Kainclean.jpg";
import imagenineteen from "../../Assets/Fatality.jpg";
import imagetwenty from "../../Assets/Its a Me.jpg";
import imagetwentyone from "../../Assets/Sinjin1.jpg";
import imagetwentytwo from "../../Assets/Pane.jpg";
import imagetwentythree from "../../Assets/Reaper2.jpg";
import imagetwentyfour from "../../Assets/Orion2clean.jpg";
import imagetwentyfive from "../../Assets/octopencil.jpg";
import imagetwentysix from "../../Assets/Spike1 copy.jpg";
import imagetwentyseven from "../../Assets/Flame.jpg";
import imagetwentyeight from "../../Assets/Sinjin.jpg";
import imagetwentynine from "../../Assets/Alpha12clean.jpg";
import imagethirty from "../../Assets/Angel.jpg";
import imagethirtyone from "../../Assets/Cyborg2clean.jpg";
import imagethirtytwo from "../../Assets/Demon1clean.jpg";
import imagethirtythree from "../../Assets/Demon3.jpg";

function Drawingpage() {

  const studies = [
    imageone,
    imagetwo,
    imagethree,
    imagefour,
    imagefive,
    imagesix
  ];

  const illustrations = [
    imageten,
    imageeleven,
    imagetwelve,
    imagenine,
    imagethirdteen,
    imagefifteen,
    imagesixteen,
    imageeighteen,
    imagetwentyone,
    imagetwentytwo,
    imagetwentythree,
    imagetwentyfour,
   
    imagetwentysix,
    imagetwentyseven,
    imagetwentyeight,
    imagetwentynine,
    imagethirty,
    imagethirtyone,
    imagethirtytwo,
    imagethirtythree
  ];

  const design = [
    imageseven,
    imageseventeen
  ];

  const renderImages = (images) => (
    <Row className="g-4">
      {images.map((img, index) => (
        <Col lg={4} md={6} sm={12} key={index}>
          <img src={img} className="portfolio-image" alt="" />
        </Col>
      ))}
    </Row>
  );

  return (
    <div className="aboutpagebackground">

      <Container>

        <h4 className="section-title">Drawing Studies</h4>
        {renderImages(studies)}

        <h4 className="section-title mt-5">Digital Illustrations and Skecthes</h4>
        {renderImages(illustrations)}

        <h4 className="section-title mt-5">Graphic Design</h4>
        {renderImages(design)}

      </Container>

    </div>
  );
}

export default Drawingpage;